module.exports = __webpack_public_path__ + "img/morenhead.c72cc44d.png";